
  import { Vue, Component } from 'vue-property-decorator';
  import { data } from './mc-waste.data';
  import { clone } from '@/utils';
  import { MealCountDto } from '@/models';

  @Component
  export default class McWasteTests extends Vue {
    vm = data.vm;

    inputChanged() {

    }

    created() {
      
    }

    mounted() {
      this.$store.state.auth.user = data.user;
    }
  }
